"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preact = require("preact");

var ArrowIcon = function ArrowIcon(_ref) {
  var width = _ref.width,
      height = _ref.height,
      color = _ref.color,
      className = _ref.className;
  return (0, _preact.h)(
    "svg",
    { xmlns: "http://www.w3.org/2000/svg", width: width, height: height, viewBox: "0 0 17 11", className: className },
    (0, _preact.h)("path", { fill: color, "fill-rule": "nonzero", d: "M.43 5.597a.5.5 0 0 1 .5-.5h13.998l-3.68-3.674a.497.497 0 0 1 0-.707.5.5 0 0 1 .707 0l4.54 4.531a.5.5 0 0 1-.098.784.506.506 0 0 1-.077.1l-4.365 4.363a.5.5 0 1 1-.707-.707l3.69-3.69H.93a.5.5 0 0 1-.5-.5z" })
  );
};

ArrowIcon.defaultProps = {
  width: 17,
  height: 11,
  color: '#ffffff'
};

exports.default = ArrowIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ecs/heimdall/build/components/Icon/ArrowIcon.js
// module id = 30
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38